import { render } from "./AddTeknologi.vue?vue&type=template&id=4f068b95"
import script from "./AddTeknologi.vue?vue&type=script&lang=js"
export * from "./AddTeknologi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__